<template>
  <!--  <div style="display: inline-block" >-->
  <div style="display: inline-block" class="dropup">
    <button
      class="btn btn-primary dropdown-toggle dropdown-toggle-split estimated-time-button"
      :class="{
        disabled: assignedUsers.length === 0 || userRelatedTasks.length === 0
      }"
      data-toggle="dropdown"
      @click="getTasks"
    >
      POSITION
    </button>
    <div v-if="tasks.length > 0" class="dropdown-menu position-dropdown">
      <!--    <div v-if="tasks.length > 0" class="dropdown-menu position-dropdown">-->
      <table class="table table-hover">
        <thead>
          <tr>
            <th># ID</th>
            <th>POS</th>
            <th>TYPE</th>
            <th>CONTENT</th>
            <th>START TIME</th>
            <th>EST.</th>
            <th>END TIME</th>
          </tr>
        </thead>

        <draggable
          v-model="newTaskTemp"
          @start="drag = true"
          @end="drag = false"
          :element="'tbody'"
          :options="{ group: 'tasks' }"
        >
          <tr
            v-for="element in newTaskTemp"
            :key="element.id"
            class="drag-item"
            :id="element.id"
          >
            <td style="font-weight:bold" class="td-pos-id">
              #{{ element.id }}
            </td>
            <td>
              <span v-if="element.type_id == 1">{{ element.pos }}</span>
              <span v-else>-</span>
            </td>
            <td>
              {{ getTaskType(element.type_id) }}
            </td>
            <td>{{ removeHtml(element.content) | truncate(25) }}</td>
            <td>{{ element.start_time }}</td>
            <td>{{ element.time_quantity }}</td>
            <td>{{ element.end_time }}</td>
          </tr>
        </draggable>

        <tr class="tasks-divider">
          <td colspan="7">User Related Tasks:</td>
        </tr>
        <draggable
          v-model="tasks"
          @start="drag = true"
          @end="drag = false"
          :element="'tbody'"
          :options="{ group: 'tasks' }"
          :move="moveNewTask"
        >
          <tr
            v-for="element in tasks"
            :key="element.id"
            class="drag-item"
            :class="{
              meeting: element.type_id === 2
            }"
            :id="element.id"
          >
            <td style="font-weight:bold" class="td-pos-id">
              #{{ element.id }}
            </td>
            <td>
              <span v-if="element.type_id == 1">{{ element.pos }}</span>
              <san v-else>-</san>
            </td>
            <td>
              {{ getTaskType(element.type_id) }}
            </td>
            <td>{{ removeHtml(element.content) | truncate(25) }}</td>
            <td>{{ element.start_time }}</td>
            <td>{{ element.time_quantity.toFixed(0) }}</td>
            <td>{{ element.end_time }}</td>
          </tr>
        </draggable>
      </table>
    </div>
  </div>
</template>

<script>
import draggable from "./draggable/vuedraggable";
import moment from "moment";
import {mapGetters, mapState} from "vuex";

export default {
  name: "SelectTaskPosition",
  props: {
    timeDuration: {
      type: Number
    },
    userRelatedTasks: {
      type: Array
    },
    primaryUser: {
      type: Number
    },
    assignedUsers: {
      type: Array
    }
  },
  components: {
    draggable
  },
  data() {
    return {
      tasks: [],
      tasksFromBackend: [],
      newTaskTemp: [],
      userShift: {
        start: null,
        end: null
      },
      newTaskTemplate: {
        adding_task_spent_time: null,
        id: "new",
        content: "New Task",
        type_id: 1,
        start_time: null,
        end_time: null,
        time_quantity: null,
        pos: null,
        created_at: moment(),
        updated_at: moment(),
        due_status: 3,
        is_new: 1,
        main_id: 0,
        main_task_id: 0,
        not_approved_rating: null,
        on_work: 0,
        priority_id: 2,
        stand_by: 0,
        status_id: 2,
        sub_task_pos_id: null,
        task_meetings: null
      },
      watchTasks: true,
      movedNewTask: false
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", [ "dictionaries", "salesPersonList"]),
    ...mapState("tasks", ["taskDictionaries"])
  },
  methods: {
    getUserTimeShifts() {
      // Get the role of the user that we acquired the tasks of
      let userRole = this.salesPersonList.find(
        item => item.id === this.primaryUser
      ).role;
      // Get the staring and ending shift hours of the user with the current role
      let shift = this.dictionaries.general.global_shifts.find(
        item => item.shift_role_id == userRole
      );
      // Assign the shift hours into the user shift object
      this.userShift.start = shift.start;
      this.userShift.end = shift.finish;
    },
    setInitialTaskPresentation(rawTasks) {
      for (let index = 0; index < rawTasks.length; index++) {
        // If we have a situation where the current task is followed by a meeting
        if (
          rawTasks[index + 1] &&
          rawTasks[index].type_id === 1 &&
          rawTasks[index + 1].type_id === 2
        ) {
          let currentTask = rawTasks[index];
          let meetingIndex = index + 1;
          let closestMeeting = JSON.parse(
            JSON.stringify(rawTasks[meetingIndex])
          );
          // In case there are joint meetings, we need to split only after all of them occur
          while (
            rawTasks[meetingIndex + 1] &&
            rawTasks[meetingIndex + 1].type_id === 2 &&
            (closestMeeting.end_time ===
              rawTasks[meetingIndex + 1].start_time ||
              (moment(closestMeeting.end_time).format("HH:mm:ss") ===
                this.userShift.end &&
                moment(rawTasks[meetingIndex + 1].start_time).format(
                  "HH:mm:ss"
                ) === this.userShift.start))
          ) {
            closestMeeting.end_time = rawTasks[meetingIndex + 1].end_time;
            closestMeeting.time_quantity +=
              rawTasks[meetingIndex + 1].time_quantity;
            meetingIndex++;
          }
          // If the task and the meeting times overlap - we need to do a split of the task
          if (currentTask.end_time > closestMeeting.start_time) {
            // Create the split task part
            let splitTask = JSON.parse(JSON.stringify(currentTask));
            // If the meeting ends right at the end of the shift,
            if (
              moment(closestMeeting.end_time).format("HH:mm:ss") ===
              this.userShift.end
            ) {
              // Avoid weekends
              let newTime = moment(closestMeeting.end_time);
              while (this.isWeekend(newTime.add(1, "days"))) {
                newTime.add(1, "days");
              }
              splitTask.start_time =
                newTime.format("YYYY-MM-DD") + " " + this.userShift.start;
            } else {
              // make the split part start right as the meeting ends
              splitTask.start_time = closestMeeting.end_time;
            }

            // If the meeting starts right at the start of the shift,
            // then the task should be splat starting from
            // the end of the shift of the previous day
            if (
              moment(closestMeeting.start_time).format("HH:mm:ss") ===
              this.userShift.start
            ) {
              currentTask.end_time =
                moment(currentTask.end_time)
                  .subtract(1, "days")
                  .format("YYYY-MM-DD") +
                " " +
                this.userShift.end;
            } else {
              // Make the original task end when the meeting starts
              currentTask.end_time = closestMeeting.start_time;
            }
            // Adjust the current task starting time
            if (rawTasks[index - 1] && rawTasks[index - 1].type_id === 2) {
              if (
                moment(rawTasks[index - 1].end_time).format("HH:mm:ss") ===
                this.userShift.end
              ) {
                // Avoid weekends
                let newTime = moment(rawTasks[index - 1].end_time);
                while (this.isWeekend(newTime.add(1, "days"))) {
                  newTime.add(1, "days");
                }
                currentTask.start_time =
                  newTime.format("YYYY-MM-DD") + " " + this.userShift.start;
              } else {
                // make the split part start right as the meeting ends
                currentTask.start_time = rawTasks[index - 1].end_time;
              }
            }
            // add the split task right after the meeting
            rawTasks.splice(
              meetingIndex === index + 1 ? index + 2 : meetingIndex,
              0,
              splitTask
            );
          }
        }
        // TODO: need to address extreme cases such as next or previous days
        rawTasks[index].time_quantity = moment
          .duration(
            moment(rawTasks[index].end_time).diff(rawTasks[index].start_time)
          )
          .asHours();
      }
    },
    getTasks() {
      this.getUserTimeShifts();
      // Get unprocessed user related tasks from the backend
      let rawTasks = JSON.parse(JSON.stringify(this.userRelatedTasks));
      // Update the visual presentation of the tasks (splits and such)
      this.setInitialTaskPresentation(rawTasks);
      this.tasksFromBackend = JSON.parse(JSON.stringify(rawTasks));
      this.tasks = rawTasks;

      if (this.newTaskTemp.length === 0) {
        this.setNewTaskTemplate(this.tasks);
        this.newTaskTemp.unshift(this.newTaskTemplate);
      }
    },
    setNewTaskTemplate(tasks) {
      for (let i = this.tasks.length - 1; i >= 0; i--) {
        if (tasks[i]["pos"] !== 0) {
          this.newTaskTemplate.pos = tasks[i]["pos"] + 1;
          break;
        }
      }
      // Get the time quantity in minutes
      this.newTaskTemplate.time_quantity = this.timeDuration;
      // Get the time when the task starts
      this.newTaskTemplate.start_time = moment(
        tasks[this.tasks.length - 1]["end_time"]
      )
        .add(5, "minutes")
        .format("YYYY-MM-DD HH:mm:ss");

      // Get the time when the task ends
      this.newTaskTemplate.end_time = this.getTaskEndTime(
        this.newTaskTemplate.start_time,
        this.timeDuration
      );
    },
    isWeekend(time) {
      return (
        time.format("dddd") === "Sunday" || time.format("dddd") === "Saturday"
      );
    },
    getTaskType(taskType) {
      return this.taskDictionaries.general.task_types.find(
        type => type.id === taskType
      ).title;
    },
    getTaskEndTime(oldTaskStartTime, taskDuration) {
      let relevantMeetingsIds = [];
      let endTime = 0;
      // Get the time when the shift ends for the current user
      let endShiftTime =
        moment(oldTaskStartTime).format("YYYY-MM-DD") +
        " " +
        this.userShift.end;

      // Get the time when the task starts in a moment format
      let taskStartTime = moment(oldTaskStartTime).format(
        "YYYY-MM-DD HH:mm:ss"
      );

      // Get the amount of time in minutes that is left from the
      // time the task starts and until the end of the shift
      let timeLeftInShift = moment
        .duration(moment(endShiftTime).diff(taskStartTime))
        .asMinutes();

      let taskTimeRemainder = taskDuration * 60;
      let taskToReplaceNewStart = moment(oldTaskStartTime);
      while (taskTimeRemainder > 0) {
        if (timeLeftInShift < taskTimeRemainder) {
          taskTimeRemainder -= timeLeftInShift;

          // Avoid weekends
          while (this.isWeekend(taskToReplaceNewStart.add(1, "days"))) {
            taskToReplaceNewStart.add(1, "days");
          }
          taskStartTime =
            taskToReplaceNewStart.format("YYYY-MM-DD") +
            " " +
            this.userShift.start;

          endShiftTime =
            taskToReplaceNewStart.format("YYYY-MM-DD") +
            " " +
            this.userShift.end;
          timeLeftInShift = moment
            .duration(moment(endShiftTime).diff(taskStartTime))
            .asMinutes();
        } else {
          endTime = moment(taskStartTime)
            .add(taskTimeRemainder, "minutes")
            .format("YYYY-MM-DD HH:mm:ss");

          // Get all the meetings that are in the range of the current task
          let relevantMeetings = this.userRelatedTasks.filter(item => {
            return (
              item.type_id === 2 &&
              !relevantMeetingsIds.includes(item.id) &&
              (item.start_time >= oldTaskStartTime && item.start_time < endTime)
            );
          });
          if (Array.isArray(relevantMeetings) && relevantMeetings.length) {
            // Add all the meetings ids to the array of meetings
            // that are already associated with the task
            relevantMeetings.forEach(meeting => {
              relevantMeetingsIds.push(meeting.id);
              taskTimeRemainder += meeting.time_quantity * 60;
            });
          } else {
            taskTimeRemainder -= timeLeftInShift;
          }
        }
      }
      return endTime;
    },
    removeHtml(tag) {
      return tag.replace(/<\/?[^>]+(>|$)/g, " ");
    },
    moveNewTask() {
      // TODO: what happens when moving the new task?
      // upon movement the task presentation should reset to its initial state
      // and let the user insert the task as if its the first time
      if (this.movedNewTask) {
        let rawTasks = JSON.parse(JSON.stringify(this.userRelatedTasks));
        // Update the visual presentation of the tasks (splits and such)
        this.setInitialTaskPresentation(rawTasks);
        this.watchTasks = true;
        this.tasks = rawTasks;
        // this.tasksFromBackend = JSON.parse(JSON.stringify(rawTasks));
        // for (let i = 0; i < rawTasks.length; i++) {
        //   this.tasks[i] = JSON.parse(JSON.stringify(rawTasks[i]));
        // }
        this.movedNewTask = false;
      }
      // this.tasks = rawTasks;
    }
  },
  watch: {
    timeDuration: function() {
      if (this.tasks.length > 0) {
        this.setNewTaskTemplate(this.tasks);
      }
    },
    tasks: function() {
      if (this.watchTasks) {
        // Look for the placement of he newly added task
        let tempPos = this.tasks.findIndex(task => {
          return task.id === "new";
        });
        // Different handling for if the task is present or not in the tasks array
        if (tempPos !== -1) {
          let newTaskPosition = 0;
          let newTaskStartTime = null;
          if (tempPos === this.tasks.length - 1) {
            // The new task is in the last position - we need to find the task with the previous position -
            // so we are able to know the position of the new task
            for (let i = tempPos - 1; i >= 0; i--) {
              if (this.tasks[i].type_id === 1) {
                // get the position and the starting time of the newly added task
                newTaskPosition = this.tasks[i].pos + 1;
                // TODO: handle end shift case
                newTaskStartTime = moment(this.tasks[i].end_time)
                  .add(5, "minutes")
                  .format("YYYY-MM-DD HH:mm:ss");
                break;
              }
            }
          } else {
            // The new task is either at the beginning or in the middle of the tasks array
            for (let i = tempPos + 1; i < this.tasks.length; i++) {
              if (this.tasks[i].type_id === 1) {
                // get the position and the starting time of the newly added task
                newTaskPosition = this.tasks[i].pos;
                newTaskStartTime = this.tasks[i].start_time;
                break;
              }
            }
          }
          // After we have received the position and starting time of the new task
          // we need to update the task ending time
          this.newTaskTemplate.start_time = newTaskStartTime;
          this.newTaskTemplate.pos = newTaskPosition;
          this.newTaskTemplate.end_time = this.getTaskEndTime(
            newTaskStartTime,
            this.tasks[tempPos].time_quantity
          );
          let rawTasks = JSON.parse(JSON.stringify(this.userRelatedTasks));
          // Get all the tasks that are of type task
          let taskTypeTasks = rawTasks.filter(task => {
            return task.type_id === 1;
          });
          // Sort the tasks by the position attribute
          let sortedTasks = taskTypeTasks.sort((task1, task2) => {
            return task1.pos - task2.pos;
          });
          // If the newly created task is in the last position - append it in the last spot
          if (newTaskPosition > sortedTasks.length) {
            sortedTasks.push(this.newTaskTemplate);
          } else {
            let positionIndex = sortedTasks.findIndex(task => {
              return task.pos === newTaskPosition;
            });
            // Add the new task at the relevant position
            sortedTasks.splice(positionIndex, 0, this.newTaskTemplate);

            // Iterate on all the following tasks and update their time frames
            for (let i = positionIndex + 1; i < sortedTasks.length; i++) {
              // TODO: handle end shift case
              sortedTasks[i].start_time = moment(sortedTasks[i - 1].end_time)
                .add(5, "minutes")
                .format("YYYY-MM-DD HH:mm:ss");
              sortedTasks[i].pos = sortedTasks[i].pos + 1;
              sortedTasks[i].end_time = this.getTaskEndTime(
                sortedTasks[i].start_time,
                sortedTasks[i].time_quantity
              );
            }
          }
          // Get all the tasks that are of type meeting
          let meetingTypeTasks = rawTasks.filter(task => {
            return task.type_id === 2;
          });
          // Get all the tasks as the came from the api call,
          // but with the addition of the newly added task
          rawTasks = meetingTypeTasks
            .concat(taskTypeTasks)
            .sort((task1, task2) => {
              return moment
                .duration(moment(task1.start_time).diff(task2.start_time))
                .asMinutes();
            });
          // Set the tasks presentation as though they just came from the backend
          this.setInitialTaskPresentation(rawTasks);

          this.$emit("changeNewTaskPosition", this.newTaskTemplate.pos);
          this.$emit("changeNewTaskStartTime", this.newTaskTemplate.start_time);
          this.$emit("changeNewTaskEndTime", this.newTaskTemplate.end_time);

          this.watchTasks = false;
          this.movedNewTask = true;
          this.tasks = rawTasks;
        } else {
          // TODO: handle new task not in tasks array
        }

        // //TODO step 1: after new task entered the tasks array check if its the first (special case) or in the middle of the array
        // // Look for the new task in the user related tasks array
        // // TODO step 2: iterate until we find the task with the index 'new' so we can begin processing it
        // // let tempPos = this.tasks.findIndex(task => {
        // //   return task.id === "new";
        // // });
        // // Check that the new task is in the user related tasks and has got a certain position
        // if (tempPos !== -1) {
        //   for (let index = tempPos - 1; index >= 0; index--) {
        //     this.tasks[index] = JSON.parse(
        //       JSON.stringify(this.tasksFromBackend[index])
        //     );
        //   }
        //   // TODO step 3: calculate the start and end time of the newly added task in relation to its placement in the tasks array
        //   let taskInNewPosition = null;
        //   // The new task is in the first position
        //   if (tempPos === 0) {
        //     // Get all the data about the task that is in the position we wish to replace
        //     taskInNewPosition = this.tasks[tempPos + 1];
        //     this.tasks[tempPos].start_time = taskInNewPosition.start_time;
        //     // Otherwise, the task is somewhere in the middle or the end
        //   } else {
        //     // Get all the data about the task that is in the position we wish to replace
        //     taskInNewPosition = this.tasks[tempPos - 1];
        //     this.tasks[tempPos].start_time = taskInNewPosition.end_time;
        //   }
        //   // TODO step 4: figure out a way to calculate the poisiton of the newly added task (excluding meetings or split tasks)
        //   // Assign the remaining data of the new task
        //   this.tasks[tempPos].pos = tempPos + 1;
        //   this.tasks[tempPos].end_time = this.getTaskEndTime(
        //     this.tasks[tempPos].start_time,
        //     this.tasks[tempPos].time_quantity
        //   );
        //   // TODO step 5: after calculating task end time we need to check if the next task is a meeting and if their time ranges overlap
        //   // TODO step 6: after checking the overlap we need to integrate the initial
        //   //  task presentation logic in order to split the new task if necessary and update the times of all the next tasks appropriately
        //
        //   this.$emit("changeNewTaskPosition", this.tasks[tempPos].pos);
        //   this.$emit("changeNewTaskStartTime", this.newTaskTemplate.start_time);
        //   this.$emit("changeNewTaskEndTime", this.newTaskTemplate.end_time);
        //
        //   // Iterate through all the other tasks and update their start
        //   // and end times of the task
        //   for (let index = tempPos + 1; index < this.tasks.length; index++) {
        //     this.tasks[index].pos = this.tasks[index - 1].pos + 1;
        //     this.tasks[index].start_time = this.tasks[index - 1].end_time;
        //     this.tasks[index].end_time = this.getTaskEndTime(
        //       this.tasks[index].start_time,
        //       this.tasks[index].time_quantity
        //     );
        //   }
        //   this.setInitialTaskPresentation(this.tasks);
        // } else {
        //   // TODO step 7: what happens when the new task is not in the array? - probably just reset the task presentation
        //   // let rawTasks = JSON.parse(JSON.stringify(this.userRelatedTasks));
        //   // // Update the visual presentation of the tasks (splits and such)
        //   // this.setInitialTaskPresentation(rawTasks);
        //   // this.tasksFromBackend = JSON.parse(JSON.stringify(rawTasks));
        //
        //   // If the new task is not present in the tasks array, return to the data that was
        //   // initially given from the server
        //   for (let i = 0; i < this.tasksFromBackend.length; i++) {
        //     this.tasks[i] = JSON.parse(JSON.stringify(this.tasksFromBackend[i]));
        //   }
        //   this.newTaskTemplate.start_time = this.tasks[this.tasks.length - 1][
        //     "end_time"
        //   ];
        //
        //   // Get the time when the task ends
        //   this.newTaskTemplate.end_time = this.getTaskEndTime(
        //     this.tasks[this.tasks.length - 1]["end_time"],
        //     this.newTaskTemplate.time_quantity
        //   );
        //   this.newTaskTemplate.pos = this.tasks[this.tasks.length - 1]["pos"] + 1;
        //   this.$emit("changeNewTaskPosition", this.newTaskTemplate.pos);
        //   this.$emit("changeNewTaskStartTime", this.newTaskTemplate.start_time);
        //   this.$emit("changeNewTaskEndTime", this.newTaskTemplate.end_time);
        // }
      }
    },
    newTaskTemplate: {
      handler(newTaskTemplate) {
        let tempTaskDate = {};
        tempTaskDate.startDate = moment(newTaskTemplate.start_time).format(
          "YYYY-MM-DD"
        );
        tempTaskDate.endDate = moment(newTaskTemplate.end_time).format(
          "YYYY-MM-DD"
        );
        tempTaskDate.startTime = moment(newTaskTemplate.start_time).format(
          "HH:mm"
        );
        tempTaskDate.endTime = moment(newTaskTemplate.end_time).format("HH:mm");
        this.$emit("setTaskDateFromSelectPosition", tempTaskDate);
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.position-dropdown {
  width: 564px;
  /*width: 800px;*/
  overflow-y: scroll;
  max-height: 80vh;
  /*top: 91%;*/
  /*left: 13px;*/
}
.drag-item:hover {
  background-color: #44a2d2;
  color: white;
  cursor: pointer;
}
.drag-item {
  border-bottom: 5px solid yellowgreen;
}
#new {
  background-color: #c1c1c1;
}
.tasks-divider {
  padding: 1em 0 1em 0.2em;
}
.meeting {
  background: #c68cdf;
}
.td-pos-id {
  width: 1%;
}
</style>
